<template>
  <div class="preview_6">
    <img src="@/assets/panel6-bg.png" class="panel-bg" />
    <div class="top-half_wrp" style="top: 64px">
      <div class="top-area flex align-items-center">
        <div class="bd">
          <span>{{ fps_t.current_value.is_configured ? fps_t.current_value.sen.sen_name : '--' }}</span>
        </div>
        <div class="ft">
          <div class="btn-circle">
            <img src="@/assets/sidebar/operate-w.svg" class="image" />
          </div>
        </div>
      </div>
      <div class="flex justify-content-center align-items-flex-end mt-hgr">
        <div class="flex mt-hgr text-white">
          <span class="current-value" :class="fps_t.current_value.sen && (fps_t.current_value.sen.sen_type == 2 || fps_t.current_value.sen.sen_type == 4) && 'small'">{{ fps_t.current_value.is_configured ? fps_t.current_value.sen.value : '--' }}</span>
          <span class="ml-sm">{{ fps_t.current_value.is_configured ? fps_t.current_value.sen.unit : '' }}</span>
        </div>
      </div>
    </div>
    <div class="bubble bubbling" style=""></div>
    <div class="bottom-half_wrp">
      <!--参数1 ~ 参数5-->
      <div class="sens-item text-white h5">
        <div class="bd">
          <div>{{ fps_t.param1.is_configured ? fps_t.param1.sen.sen_name : '--' }}</div>
        </div>
        <div class="ft">
          <div class="">
            <span>{{ fps_t.param1.is_configured ? fps_t.param1.sen.value : '--' }}</span>
            <span class="h9 ml-xs">{{ fps_t.param1.is_configured ? fps_t.param1.sen.unit : '' }}</span>
          </div>
        </div>
      </div>

      <div class="sens-item text-white h5">
        <div class="bd">
          <div>{{ fps_t.param2.is_configured ? fps_t.param2.sen.sen_name : '--' }}</div>
        </div>
        <div class="ft">
          <div>
            <span>{{ fps_t.param2.is_configured ? fps_t.param2.sen.value : '--' }}</span>
            <span class="h9 ml-xs">{{ fps_t.param2.is_configured ? fps_t.param2.sen.unit : '' }}</span>
          </div>
        </div>
      </div>
      <div class="sens-item text-white h5">
        <div class="bd">
          <div>{{ fps_t.param3.is_configured ? fps_t.param3.sen.sen_name : '--' }}</div>
        </div>
        <div class="ft">
          <div>
            <span>{{ fps_t.param3.is_configured ? fps_t.param3.sen.value : '--' }}</span>
            <span class="h9 ml-xs">{{ fps_t.param3.is_configured ? fps_t.param3.sen.unit : '' }}</span>
          </div>
        </div>
      </div>
      <div class="sens-item text-white h5">
        <div class="bd">
          <div>{{ fps_t.param4.is_configured ? fps_t.param4.sen.sen_name : '--' }}</div>
        </div>
        <div class="ft">
          <div>
            <span>{{ fps_t.param4.is_configured ? fps_t.param4.sen.value : '--' }}</span>
            <span class="h9 ml-xs">{{ fps_t.param4.is_configured ? fps_t.param4.sen.unit : '' }}</span>
          </div>
        </div>
      </div>
      <div class="sens-item text-white h5">
        <div class="bd">
          <div>{{ fps_t.param5.is_configured ? fps_t.param5.sen.sen_name : '--' }}</div>
        </div>
        <div class="ft">
          <div>
            <span>{{ fps_t.param5.is_configured ? fps_t.param5.sen.value : '--' }}</span>
            <span class="h9 ml-xs">{{ fps_t.param5.is_configured ? fps_t.param5.sen.unit : '' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Panel6',
  props: {
    fps_t: {
      type: Object
    },
    profile: {
      type: Object
    }
  },
  data() {
    return {
      activeFp: { fpid: null }
    }
  },
  methods: {
    getAFp(flag) {
      this.activeFp.fpid = flag
    }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
.preview_6 {
  position: relative;
  width: 390px;
  height: 844px;
  margin: 0 auto;
  background-size: 100% 100%;
  background-color: #fff;

  .panel-bg {
    position: relative;
    width: 390px;
    top: 64px;
    height: 780px;
    background-repeat: repeat-x;
    background-position: 0px 0px;
    background-size: 100% 100%;
  }
  .waving {
    animation: move_wave 15s linear infinite;
  }
  .btn-circle {
    background-color: #56b9f9;
  }

  .top-half_wrp {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 20px 0px 0px 0px;
    line-height: 1;
    z-index: 101;
  }
  .top-area {
    padding: 0 30px;
    color: #56b9f9;
    font-size: 18px;
  }
  .current-value {
    font-size: 72px;
    &.small {
      font-size: 60px;
    }
  }

  .mt-hg {
    margin-top: 25px;
  }
  .mt-hgr {
    margin-top: 15%;
  }

  .bubble {
    position: absolute;
    width: 375px;
    bottom: 0;
    min-height: 200px;
    z-index: 99;
    background-image: url(../../../assets/bubble1.png), url(../../../assets/bubble2.png);
    top: 86px;
  }
  .bubbling {
    animation: bubble_up 15s linear infinite;
  }

  .bottom-half_wrp {
    position: absolute;
    top: 55%;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 30px 30px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .sens-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 26px;
  }
  .sens-item + .sens-item {
    margin-top: 10px;
  }

  @keyframes bubble_up {
    0% {
      background-position: bottom left, top right, 0 0, 0 0;
    }
    50% {
      background-position: top right, bottom left, 0 0, 0 0;
    }
    100% {
      background-position: bottom left, top right, 0 0, 0 0;
    }
  }
  @keyframes move_wave {
    0% {
      background-position-x: 0;
      background-position-y: 75px;
    }
    50% {
      background-position-y: 75px;
    }
    100% {
      background-position-x: 500px;
      background-position-y: 75px;
    }
  }
}
</style>
